"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CreateInvoiceTax = /** @class */ (function () {
    function CreateInvoiceTax(taxId, amount) {
        this.taxId = taxId;
        this.amount = amount;
    }
    __decorate([
        mobx_1.observable
    ], CreateInvoiceTax.prototype, "taxId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceTax.prototype, "amount", void 0);
    return CreateInvoiceTax;
}());
exports.CreateInvoiceTax = CreateInvoiceTax;
//# sourceMappingURL=InvoiceTax.js.map